import { collection, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { firebaseStore } from "../firebase";
import axios from "axios";
let rooms = {};
let messagesList = {};
export const unreadCount = async (user_id) => {
    // 一ヶ月前のunixtime
    const deadline = Math.floor((Date.now() - 1000 * 3600 * 24 * 30) / 1000);
    const q = query(collection(firebaseStore, "rooms"), where("userId", "==", user_id));
    const res = await getDocs(q);
    for (const room of res.docs) {
        let lastUpdatedAt = 0;
        rooms[room.id] = room.data();
        const mq = query(collection(firebaseStore, "rooms", room.id, "messages"), orderBy("sentAt"), limit(100));
        const data = await getDocs(mq);
        if (data.size == 0) {
            delete rooms[room.id];
            continue;
        }
        const messages = [];
        data.forEach((message) => {
            // 最終送信日時を取得
            lastUpdatedAt = message.data().sentAt.seconds;
            messages.push(message.data());
        });
        // チャット一覧には１ヶ月以前は表示させない仕様のためルーム削除
        if (deadline > lastUpdatedAt) {
            delete rooms[room.id];
            continue;
        }
        messagesList[room.id] = messages;
    }
    // サプライヤー企業名をAPIから取得する
    let weboothSlotIds = Object.values(rooms).map((room) => room.weboothSlotId);
    // 重複を削除
    let setWeboothSlotIds = new Set(weboothSlotIds);
    weboothSlotIds = Array.from(setWeboothSlotIds);
    const response = await axios.get("/api/user/get-webooth-supplier-name", { params: { webooth_slot_ids: weboothSlotIds } });
    for (const roomId in rooms) {
        const data = response.data[rooms[roomId].weboothSlotId];
        if (data === undefined) {
            delete rooms[roomId];
            delete messagesList[roomId];
        }
    }
    const unreadCount = countUnread();
    try {
        axios.post("/api/u/mypage/chat/count", { userId: user_id, chatUnReadCount: unreadCount });
        const span = document.getElementById("side-menu-chat-unread-count");
        if (!span)
            return;
        span.className = "";
        if (unreadCount > 0) {
            span.innerHTML = unreadCount.toString();
            span.className = "counter";
        }
        else {
            span.innerHTML = "(" + unreadCount.toString() + ")";
        }
    }
    catch (error) {
        window.console.error(error);
    }
};
export const countUnread = () => {
    if (rooms == null) {
        return 0;
    }
    const len = Object.entries(rooms).filter(([index, room]) => {
        return !opened(index);
    })?.length ?? 0;
    return len;
};
export const opened = (roomId) => {
    const room = rooms[roomId];
    const messages = messagesList[roomId];
    if (room == null || messages == null || messages.length < 1) {
        return false;
    }
    return !messages.some((message) => message.supplierMessage && !message.opened);
};
